<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
          <li class="active">
            <router-link to="/admin">Dashboard</router-link>
          </li>
          <li class="active"><a href="#">Employee</a></li>
        </ol>
      
        <!-- table Part -->
        <div class="row">
          <div class="col-md-12">
           <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
        </div>
          <div class="col-md-12">
            <div class="panel panel-default" id="panel-inline">
              <div class="panel-heading">
                <div class="panel-ctrls"></div>
              </div>
              <div class="panel-body no-padding">
                <div class="col-md-3">
                  <div id="search-box">
                    <div class="form-group">
                      <input
                        type="text"
                        class="search-query form-control"
                        placeholder="Search"
                        v-model="searchText"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="form-group">
                    <button
                      type="button"
                      v-on:click="getAllLeads(1)"
                      class="btn btn-outline-primary"
                    >
                      Search
                    </button>
                  </div>
                </div>
                <div class="col-md-3">
                <div class="form-group">                
                  <button v-if="$can('Create','OrganisationSetup::Employee Add')" class="btn btn-primary submitbtn btn-raised" @click="$router.push('/addEmployee')">Employee Add</button>
                </div></div>
                 <div class="col-md-3 form-group">
          <div  v-if="$can('Create','OrganisationSetup::Employee Add') || $can('Delete','OrganisationSetup::Employee Deleted List')" style="float:left;margin-right:10px;">
            <button  class="btn btn-danger submitbtn btn-raised" @click="$router.push('/OrgEmployeesDeleteList')">Delete List <i class="material-icons">delete</i></button>
          </div>
           <div v-if="$can('Download','OrganisationSetup::Employee List')">
          <button class="btn btn-default submitbtn btn-raised" @click="export_file">Export <i class="material-icons">file_download</i></button>   
           </div>
        </div>
                <table
                  class="table table-striped table-bordered"
                  cellspacing="0"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Mobile No.</th>
                      <th>Email Id</th>
                      <th>Employee Code</th>
                      <th>Role</th>
                      <th v-if="!$can('Delete','OrganisationSetup::Employee Deleted List')">Status</th>
                      <th v-if="$can('Delete','OrganisationSetup::Employee Deleted List')">Status</th>
                      <th >Action</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                  <!-- <tr class="odd gradeX"> -->
                  <tr
                    v-for="(item, index) in users_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td>{{ item.first_name+' '+item.last_name }}</td>
                    <td>{{ item.phone }}</td>
                    <td>{{item.email}}</td>
                    <td>{{item.employee_code}}</td>
                    <td>{{item.name}}</td>
                    <td v-if="!$can('Delete','OrganisationSetup::Employee Deleted List')">{{item.active=== "1" ? "Active": "Inactive"}}</td>
                    <td class="statusLIATopan" v-if="$can('Delete','OrganisationSetup::Employee Deleted List')">
                    <a href="#" @click="DeactivateEmployee(item.id)">{{item.active=== "1" ? "Active": "InActive"}}</a>
                    </td>
                    <td class="statusLIATopan"  >
                      <router-link
                        :to="{
                          name: 'editEmployees',
                          params: { id: item.id },
                        }"
                        >Edit</router-link
                      >
                    </td>
                   
                  </tr>
                </tbody>
                </table>
                <!--end table-->
              </div>
              <div class="panel-footer">
                <paginate
                  :page-count="TotalPage"
                  :click-handler="getAllLeads"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                >
                </paginate>
              </div>
            </div>
          </div>
        </div>
        <!--  table part / -->
      </div>
    </div>
    <div id="externalScript"></div>
  </div>
</template>
<script>
import moment from 'moment'

import Paginate from 'vuejs-paginate';
import postscribe from 'postscribe';
import commonServices from '../../services/common-services';
export default {
  name: 'orgEmployees',
  data() {
    return {
      users_data: [],
      TotalPage: 1,
      searchText: '',
      pageSize: 10,
      currentPage: 1,
      SuccessMessage:"",
      ErrorMessage:""
    };
  },
  components: {
    Paginate,
  },
  methods: {
    DeactivateEmployee(id){
      let params = {}
      params ="id="+id
       commonServices
        .delete('kspgAPI/BrandEmployee', params)
        .then((response) => {
            this.SuccessMessage = response.data.message;
            if (response.data.status) {
              this.getAllLeads(1);
              this.SuccessMessage = response.data.Messaage
            }
          },
          (error) => {
            //   this.loading = false;
            this.ErrorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          })
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
        setTimeout(() => (this.SuccessMessage = false), 5000);   
        setTimeout(() => (this.ErrorMessage = false), 5000);
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }
      params['active'] = '1';
      return params;
    },
    getAllLeads(pageNum) {
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      commonServices
        .get('kspgAPI/BrandEmployee/list', params)
        .then((response) => {
          const {
            users_data,
            totalItems,
            currentPage,
            TotalPage,
          } = response.data;
          this.users_data = users_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
        })
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
        setTimeout(() => {loader.hide()}, 2000)
    },
    export_file(){              
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        0,
        this.pageSize
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/BrandEmployee/export', params)
        .then((response) => {
            if(response.data.status){
               var link = document.createElement('a');
                link.href = response.data.filepath;
                link.target = "_blank";
                link.click();              
            } else {
              alert(response.data.message);
            }
           setTimeout(() => {loader.hide()}, 1000);
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
          alert(e.response.data.message);
          setTimeout(() => {loader.hide()}, 1000);
        });
    },
    format_date(value){
         if (value) {
           return moment(String(value)).format('DD-MM-YYYY')
          }
      },
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  mounted() {
    this.getAllLeads(1),
    postscribe(
      '#externalScript',
      /* eslint-disable-next-line */
      `<\script type="application/javascript" src="assets/js/Utility_ApplicationUsed.js"><\/script>`
    );
  },
  filters: {
        truncate: function (text, length, suffix) {
            if(!text){
              return text;
            }
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },
    }
};
</script>
